import {doApiPatch, CallResult, doApiPatchFormData} from "./Requests";

export const uploaderApi = {
    uploadServiceModuleIcon: async (serviceModuleId: number, file: File | null): Promise<CallResult<string>> => {
        const formData = new FormData();
        if (file) formData.append("file", file);
        return await doApiPatchFormData(`/api/companies/current/servicemodules/${serviceModuleId}/icon`, formData);
    },

    uploadActionModuleIcon: async (actionModuleId: number, file: File | null): Promise<CallResult<string>> => {
        const formData = new FormData();
        if (file) formData.append("file", file);
        return await doApiPatchFormData(`/api/companies/current/actionmodules/${actionModuleId}/icon`, formData);
    },

    uploadCalendarEventIcon: async (
        serviceModuleId: number,
        eventId: number,
        file: File | null
    ): Promise<CallResult<string>> => {
        const formData = new FormData();
        if (file) formData.append("file", file);
        return await doApiPatchFormData(
            `/api/companies/current/servicemodules/calendars/${serviceModuleId}/events/${eventId}/icon`,
            formData);
    },
};